module.exports = "/fast-coin/img/coin/anim/in/coin_in_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_000.png
// module id = 2270
// module chunks = 5